import React, { useCallback } from 'react';

import { StyledLabel, StyledRequiredSpan, StyledTextArea } from '@/components/Form/styles';
import { StyledFlexColumn } from '@/layout/FlexLayout';

import type { InputHTMLAttributes, ChangeEvent } from 'react';

interface TextAreaProps<Key = string> extends InputHTMLAttributes<HTMLTextAreaElement> {
  handleValue: (key: Key, value: string) => void;
  label?: string;
  required?: boolean;
  fieldKey: Key;
}

export function TextArea({ fieldKey, required, onChange, handleValue, label, ...HTMLProps }: TextAreaProps) {
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLTextAreaElement>) => {
      if (onChange) onChange(event);
      if (handleValue) handleValue(fieldKey, event.target.value);
    },
    [handleValue, fieldKey, onChange],
  );

  return (
    <StyledFlexColumn>
      {label && (
        <StyledLabel>
          {label} {required && <StyledRequiredSpan>*</StyledRequiredSpan>}
        </StyledLabel>
      )}
      <StyledTextArea {...HTMLProps} onChange={handleChange} />
    </StyledFlexColumn>
  );
}
